import { GET_SECURETEXT, GET_SECURETEXTS,SYSTEM_TOAST_SUCCESS_MESSAGE} from "./types";

import { serverEndPoint } from './Utils';
import axios from 'axios';

export const getSecureTexts = () => { 
    return async (dispatch) => { 
        try {
            const { data, status } = await axios.get(`${serverEndPoint}/secure/getSecureTexts`);
            if(status === 200) { 
                let secureTexts = data.map((c) => { 
                    let data = c.created_at.substring(0, 10).split('-').reverse().join('-')
                    c.created_at = data 
                    return c  
                })

                dispatch({
                    type: GET_SECURETEXTS,
                    payload: secureTexts,
                });
            } 
        } catch (error) {
            console.log(error);  
        }
    };     
}; 

export const getSecureTextById = (_id) => { 
    return async (dispatch) => { 
        try {
           const {data,status} = await axios.get(`${serverEndPoint}/secure/getSecureTextById/${_id}`); 
           if(status === 200) { 
             await dispatch({ 
                type: GET_SECURETEXT,
                payload: data[0],
             })
           }  
        } catch (error) {
            console.log(error);  
        }
    };
};

export const deleteSecureTextById = (_id) => { 
    return async (dispatch) => { 
        try {
            const {status} = await axios.delete(`${serverEndPoint}/secure/deleteSecureTextById/${_id}`);
            if(status === 200) { 
                dispatch({
                    type: SYSTEM_TOAST_SUCCESS_MESSAGE,
                    payload: 'Secure Text Deletado!',
                  });
            }
        } catch (error) {
            console.log(error);
        }
    }; 
}; 

export const createSecureText = (params) => { 
    return async (dispatch) => {
    try {
        const { status } = await axios.post(`${serverEndPoint}/secure/createSecureText`, params);
        if (status === 200) {
            dispatch({
              type: SYSTEM_TOAST_SUCCESS_MESSAGE,
              payload: 'Secure Text Adicionado!',
            });
          }    
        } catch (error) {
           console.log(error);             
        }
    };    
}; 

export const updateSecureText = (params) => { 
    return async (dispatch) => { 
        try {
            const { status } = await axios.put(`${serverEndPoint}/secure/updateSecureText`, params);
            if(status === 200) { 
                dispatch({
                    type: SYSTEM_TOAST_SUCCESS_MESSAGE,
                    payload: 'Secure Text Alterado!',
                });
            }
        } catch (error) {
          console.log(error);  
        }
    }
}




